export default function Page404(props){
    return <div>
        <h1>404</h1>
        <p>Page Not Found</p>
    </div>
}